import React, { Fragment, useEffect, useState } from "react";
import {
  Box,
  TextField,
  MenuItem,
  Typography,
  InputLabel,
  Button,
  IconButton,
  Tooltip,
} from "@mui/material";
import InfoOutlined from "@mui/icons-material/InfoOutlined";

import DescriptionIcon from "@mui/icons-material/Description";
const paramOptions = ["{{NAME}}", "{{phone}}"];
const paramMapping = { 1: "{{NAME}}", 2: "{{phone}}" };

const DynamicParameters = ({
  errors,
  watch,
  register,
  setSelectedParams,
  customFiles,
  setCustomFiles,
}) => {
  const [params, setParams] = useState({});
  // Store custom file inputs

  const messageBody = watch("template_content", "");

  useEffect(() => {
    if (!messageBody.trim()) {
      setParams({});
      setCustomFiles({});
      return;
    }

    const regex = /\{\{(\d+)\}\}/g;
    const matches = [...messageBody.matchAll(regex)];

    const newParams = {};

    matches.forEach((match) => {
      const paramId = match[1]; // Extract number (e.g., "0", "1")
      newParams[paramId] =
        params[paramId] || paramMapping[paramId] || paramOptions[0];
    });

    setSelectedParams(newParams);
    setParams(newParams);
  }, [messageBody]);

  const handleParamChange = (paramId, value) => {
    setParams((prev) => ({ ...prev, [paramId]: value }));

    if (value !== "Custom") {
      setCustomFiles((prev) => {
        const updatedFiles = { ...prev };
        delete updatedFiles[paramId]; // Remove custom file if switching from Custom
        return updatedFiles;
      });
    }
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setCustomFiles(file);
    }
    event.target.value = "";
  };
  console.log(customFiles);

  return (
    <Fragment>
      <Box display={"flex"} justifyContent={"space-between"}>
        <Tooltip
          arrow
          title={
            <>
              <Typography variant="body2" ml={1}>
                {"{{1}}"}: Name of the lead
              </Typography>
              <Typography variant="body2">
                {"{{2}}"}: Phone number of the lead
              </Typography>
            </>
          }
        >
          <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <InfoOutlined className="tooltip" style={{ cursor: "pointer" }} />
            <InputLabel
              sx={{
                color:
                  errors?.template_content?.type === "required"
                    ? "red !important"
                    : "inherit",
                pb: 1,
              }}
            >
              Template Content
            </InputLabel>
          </span>
        </Tooltip>
      </Box>
      <TextField
        {...register("template_content", { required: true })}
        variant="outlined"
        fullWidth
        multiline
        
        placeholder="e.g., Hi {{1}}, welcome to Desai Homes. We'll contact you {{2}}."
        rows={3}
        sx={{ width: "100%" }}
      />

      {/* Render dropdowns dynamically */}
      {Object.keys(params).map((paramId) => (
        <Box key={paramId} sx={{ mt: 2 }}>
          <Typography variant="body2">
            Parameter {paramId} ({params[paramId]}):
          </Typography>
          <TextField
          
            select
            fullWidth
            value={params[paramId]}
            onChange={(e) => handleParamChange(paramId, e.target.value)}
          >
            {paramOptions.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>

          {/* Show file input if "Custom" is selected */}
        </Box>
      ))}

     <Box sx={{ mt: 1, width: "100%", display: "flex", alignItems: "center", gap: 2 }}>
  <Button component="label" variant="outlined" startIcon={<DescriptionIcon />}>

    <input
      type="file"
      accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
      hidden
      onChange={(e) => handleFileUpload(e)}
    />
  </Button>

  <Typography variant="body2">
    {customFiles?.name ? `Selected: ${customFiles.name}` : "Document Uploader (Max file size: 5MB)"}
  </Typography>
</Box>

    </Fragment>
  );
};

export default DynamicParameters;
